export default function calcMinEquity(LTV){
    if(LTV<85){
        return 10000
    }
    else return 15000
}